import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nextToPromise, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource, invalidateResource } from "kea-resource";
import * as rx from "rxjs";
import { FacturaForm } from "./form";
import { ClaveMonedaSat } from "app/features/selectores/index";

const FacturaFormRx = componentToRx(FacturaForm);
type Entity = models.FacturaDto;
const resource = resources.Factura;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value?: Entity;
}
class FacturaEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    idStr = (props: Props, state: State) => this.props.match.params.id;
    id = createSelectorRx(this.idStr, id => (id === "new") ? "new" : (id === "newNC") ? "newNC" : Number.parseInt(id));
    esNuevo = createSelectorRx(this.id, id => id === "new");
    esNotaCargo = createSelectorRx(this.id, id => id === "newNC");

    nuevoValueDefault = (props: Props, state: State) => ({
        TipoCaptura: models.TipoCaptura.Manual,
        Origen: models.OrigenFactura.Manual,
        TipoCambio: 1,
        FechaFactura: new Date(),
        FechaPolizaContable: new Date(),
        ReceptorFactura: {} as models.ReceptorFactura,
        EsNotaDeCredito: false,
        EsTimbrada: false,
    } as Entity)

    valueFromResource = createSelectorRx(this.id, this.esNuevo, this.esNotaCargo, (id, esNuevo, esNotaCargo) => ((esNuevo || esNotaCargo) ? toObservable(undefined) : observeResource(resource.get, id)) as rx.Observable<(Entity | undefined)>);
    valueFromState = (props: Props, state: State) => state.value;

    //TODO: Hacer el arreglo del selector sincrono aqui: 
    datosInicioFactura = (props: Props, state: State) => observeResource(resource.DatosInicioFactura);
    nuevoValue = createSelectorRx(this.nuevoValueDefault, this.datosInicioFactura, (nuevoValue, dif) =>
        ({ ...nuevoValue, ClaveSatMoneda: dif.ClaveSatMonedaManual, ClaveSatRegimenFiscalEmisor: dif.ClaveSatRegimenFiscalManual }) as Entity);

    nuevoValueOrigen = createSelectorRx(this.nuevoValue, this.esNotaCargo, (nuevoValue, esNotaCargo) =>
        ({ ...nuevoValue, Origen: esNotaCargo ? models.OrigenFactura.NotaDeCargo : models.OrigenFactura.Manual }) as Entity
    );

    value = createSelectorRx(this.valueFromState, this.valueFromResource, this.nuevoValueOrigen, (state, resource: (Entity | undefined), nuevo) => state || resource || nuevo);

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onRefresh = async () => {
        await invalidateResource(resources.Factura);
        await new Promise<void>(resolve => this.setState({ value: undefined }, resolve))
    };
    onGuardar = async () => {
        const id = this.id(this.props, this.state);
        const valueObs = this.value(this.props, this.state);
        const value = await nextToPromise(valueObs);

        const func = (id === "new" || id === "newNC") ? resource.add : resource.update;
        var idFactura = await func(value);
        if (id == "new") {
            var factura = await resource.get(idFactura);
            await kea.message("Se agregó la factura " + factura.SerieFolio)
        }
        history.go("../");
    }

    onGuardarSinSalir = async () => {
        const id = this.id(this.props, this.state);
        const valueObs = this.value(this.props, this.state);
        const value = await nextToPromise(valueObs);
        await resource.update(value);
        await kea.message("Factura guardada", "", "success");
    }

    onGuardarCobranza = async () => {
        const id = this.id(this.props, this.state);
        const valueObs = this.value(this.props, this.state);
        const value = await nextToPromise(valueObs);
        await resource.ActualizarBanderasCobranza(value);
        await kea.message("Banderas de cobranza actualizadas", "", "success");

    }

    render() {
        const value = this.value(this.props, this.state);
        const id = this.id(this.props, this.state);
        return <FacturaFormRx
            value={value}
            onChange={this.onChange}
            nuevo={id == "new"}
            permisos={resources.User.PermisoRx}
            onGuardar={this.onGuardar}
            onRefresh={this.onRefresh}
            onGuardarBanderasCobranza={this.onGuardarCobranza}
            onGuardarSinSalir={this.onGuardarSinSalir} />;
    }

}

export const FacturaEdit = withRouter(FacturaEditComp);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/edit/edit.tsx